export enum Query {
  USER = 'USER',
  PUBLIC_WEBSITE_INFO = 'PUBLIC_WEBSITE_INFO',
  MEETING_BOOKING_SETTINGS = 'MEETING_BOOKING_SETTINGS',
  TIME_SLOT_SETTINGS = 'TIME_SLOT_SETTINGS',
  DETAILED_JOB_CONFIG = 'DETAILED_JOB_CONFIG',
  PAYMENT_PROVIDERS = 'PAYMENT_PROVIDERS',
  ORDER = 'ORDER',
  CLIENT = 'CLIENT',
  DETAILED_MEETING = 'DETAILED_MEETING',
  DETAILED_MEETING_BATCH = 'DETAILED_MEETING_BATCH',
}

// limits retry attempts
export const MAX_RETRY_COUNT = 10;
// minimal timout between attempts
export const MIN_TIMEOUT = 1000;
// maximum timout between attempts
export const MAX_TIMEOUT = 60000;
// indicates how fast timout between attempts will be increase.
// f.e. factor=1: 1000, 2000, 3000, 4000, 5000..., with factor=2: 1000, 2000, 4000, 8000, 16000
export const DELAY_SCALE_FACTOR = 2;
// adds tiny randomization in calculated timeout between retry attempts.
// f.e. factor=2: 1184, 2377, 4041, 8693, 17030...
export const USE_JITTER = true;
